import React from "react";
import { useTranslation } from "react-i18next";

// const PhoneIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     className="h-5 w-5 text-indigo-400 group-hover:text-indigo-300 transition-colors duration-150"
//     fill="none"
//     viewBox="0 0 24 24"
//     stroke="currentColor"
//     strokeWidth={2}
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.308 1.154a11.034 11.034 0 005.378 5.378l1.154-2.308a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//     />
//   </svg>
// );

const EmailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 text-indigo-400 group-hover:text-indigo-300 transition-colors duration-150"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

// const LocationIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     className="h-5 w-5 text-indigo-400" // Removed group-hover as it's not an interactive element host here
//     fill="none"
//     viewBox="0 0 24 24"
//     stroke="currentColor"
//     strokeWidth={2}
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
//     />
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
//     />
//   </svg>
// );

// Using a generic LinkIcon for social parent, specific icons for each platform would be even better.
// eslint-disable-next-line no-unused-vars
const SocialLinkIcon = () => (
  // Renamed from LinkIcon for clarity in this context
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 text-indigo-400"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
    />
  </svg>
);

const Footer = () => {
  const { t } = useTranslation(); // Assuming you have translations for "Call Us", "Email Us", etc.

  // Contact Data (could be moved to a config file or passed as props)
  const contact = {
    phone: "Not available", // Or actual phone: "+1 234 567 890"
    phoneHours: "Mon - Fri, 9am - 6pm",
    email: "livethewill@gmail.com",
    emailResponse: t("footer.emailResponse", "We reply within 24 hours."),
    address: {
      line1: "LiveTheWill Music Group",
      line2: "123 Rock Street, Music City, USA 45678",
    },
    social: [
      {
        name: "Instagram",
        url: "https://www.instagram.com/livethewill",
        // icon: <InstagramIcon /> // If you had a specific Instagram icon
      },
      {
        name: "YouTube",
        url: "https://www.youtube.com/@livethewill7257", // Placeholder, replace with actual YouTube link
        // icon: <YouTubeIcon /> // If you had a specific YouTube icon
      },
    ],
  };

  return (
    <footer className="bg-slate-900 text-gray-300 pt-16 pb-8 z-[100] w-full">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Column 1: Brand Info */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h3 className="text-2xl font-bold text-white mb-4">
              LiveTheWill
            </h3>
            <p className="text-gray-400 text-sm max-w-xs">
              {t(
                "footer.information",
                "Dedicated to bringing unique musical experiences. Stay connected with us."
              )}
            </p>
          </div>

          {/* Column 2: Contact Info */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h4 className="text-lg font-semibold text-white mb-4">
              {t("footer.contactUs", "Contact us")}
            </h4>
            <ul className="space-y-5 w-full flex flex-col items-center md:items-start">
              <li className="flex items-start group">
                <span className="flex-shrink-0 w-7 h-7 bg-slate-800 rounded-full flex items-center justify-center mt-1 mr-3">
                  <EmailIcon />
                </span>
                <div className="text-left">
                  <p className="font-medium text-gray-200">
                    {t("footer.emailUs", "Email us")}
                  </p>
                  <a
                    href={`mailto:${contact.email}`}
                    className="text-indigo-400 hover:text-indigo-300 transition-colors duration-150 block"
                  >
                    {contact.email}
                  </a>
                  <p className="text-xs text-gray-500">
                    {contact.emailResponse}
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* Column 3: Social Links */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h4 className="text-lg font-semibold text-white mb-4">
              {t("footer.followUs", "Follow us")}
            </h4>
            <ul className="space-y-3 w-full flex flex-col items-center md:items-start">
              {contact.social.map((socialLink) => (
                <li key={socialLink.name} className="flex items-center group">
                  <a
                    href={socialLink.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-400 hover:text-indigo-300 transition-colors duration-150 flex items-center"
                  >
                    {socialLink.name}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 ml-1.5 opacity-70 group-hover:opacity-100"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Livethewill.{" "}
            {t("footer.allRightsReserved", "All Rights Reserved.")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
